export const visibleComponents = {}

export const setVisible = (componentId) => {
  visibleComponents[componentId] = true
}

export const getVisible = (componentId) => visibleComponents[componentId]
